// extracted by mini-css-extract-plugin
export default {"accordion":"folderlevelOne_accordion__cFSS-"};